import * as React from 'react';
import { useVariableWithStableRef } from './useVariableWithStableRef';

export function useCloseHandlersWithoutDuplicatedCalls(close: () => void, isOpened: boolean) {
    const closeRef = useVariableWithStableRef(close);
    const shouldDeactivateInvokeCloseRef = React.useRef(false);

    React.useEffect(() => {
        if (isOpened) {
            shouldDeactivateInvokeCloseRef.current = true;
        }
    }, [isOpened]);

    const focusTrapDeactivationClose = () => shouldDeactivateInvokeCloseRef.current && closeRef.current?.();

    const buttonClickClose = () => {
        shouldDeactivateInvokeCloseRef.current = false;
        close();
    };

    return { focusTrapDeactivationClose, buttonClickClose };
}
